import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AdminShell from './AdminShell';
import { getStats, getAdminBookings } from '../../api/client';

const STATUS_LABELS = {
  pending: 'Ожидает',
  confirmed: 'Подтверждено',
  paid: 'Оплачено',
  cancelled: 'Отменено',
  completed: 'Завершено',
};

function formatDate(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' });
}

function formatShortDate(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' });
}

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    getStats().then(setStats);
    getAdminBookings({ limit: 5 }).then(setRecent);
  }, []);

  return (
    <AdminShell title="Дашборд">
      {stats && (
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-value">{stats.bookings_pending}</div>
            <div className="stat-label">⏳ Ожидают подтверждения</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{stats.bookings_confirmed}</div>
            <div className="stat-label">✅ Подтверждено</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{stats.bookings_today}</div>
            <div className="stat-label">📅 Заявок сегодня</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">
              {new Intl.NumberFormat('ru-RU').format(stats.revenue_this_month_rub)} ₽
            </div>
            <div className="stat-label">💰 Выручка за месяц</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{stats.active_apartments}</div>
            <div className="stat-label">🏠 Активных квартир</div>
          </div>
        </div>
      )}

      <div className="card">
        <div style={{ padding: '20px 20px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ fontSize: 17, fontWeight: 700 }}>Последние заявки</h2>
          <Link to="/admin/bookings" style={{ fontSize: 14 }}>Все бронирования →</Link>
        </div>
        <div className="admin-table-wrap" style={{ marginTop: 12 }}>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Номер</th>
                <th>Гость</th>
                <th>Квартира</th>
                <th>Даты</th>
                <th>Сумма</th>
                <th>Статус</th>
              </tr>
            </thead>
            <tbody>
              {recent.map(b => (
                <tr key={b.id}>
                  <td><Link to={`/admin/bookings/${b.id}`}>{b.booking_ref}</Link></td>
                  <td>
                    <div style={{ fontWeight: 600 }}>{b.guest_name}</div>
                    <div style={{ fontSize: 12, color: 'var(--gray-500)' }}>{b.guest_phone}</div>
                  </td>
                  <td>{b.apartment_name}</td>
                  <td style={{ fontSize: 13 }}>{formatShortDate(b.check_in)} → {formatShortDate(b.check_out)}</td>
                  <td style={{ fontWeight: 700 }}>{new Intl.NumberFormat('ru-RU').format(b.total_price_rub)} ₽</td>
                  <td><span className={`badge badge-${b.status}`}>{STATUS_LABELS[b.status] || b.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AdminShell>
  );
}